export default __webpack_public_path__ + "static/undppa-ic-logo-e68e7df4b15dce5ed71b211cdf2f1afa.png";